export default {
  name: 'informations_manual_domiciliation_iban',
  component_path: 'modules/procedures/blocks/BlockInputIban',
  static_mandatory: ['required', 'iban']
}